import { useSearchParams } from 'react-router-dom';
import IcpFormPreview from '../components/IcpFormPreview';
import './PreviewPage.css';

export default function PreviewPage() {
  const [params] = useSearchParams();
  const domain = params.get('domain') || '';
  const company = params.get('company') || '';
  const industry = params.get('industry') || '';
  const location = params.get('location') || '';
  const leadId = params.get('lead_id') || '';
  const packageType = params.get('package_type') || 'domain_only';

  const orderUrl = `/order?domain=${encodeURIComponent(domain)}&package_type=${encodeURIComponent(packageType)}${leadId ? `&lead_id=${encodeURIComponent(leadId)}` : ''}${company ? `&company=${encodeURIComponent(company)}` : ''}${industry ? `&industry=${encodeURIComponent(industry)}` : ''}${location ? `&location=${encodeURIComponent(location)}` : ''}`;

  const displayDomain = domain || 'yourbusiness.com';
  const displayName = company || displayDomain.split('.')[0];

  return (
    <div className="preview-root">
      <div className="preview-content-pad">
        <div className="preview-stage">
          <IcpFormPreview
            domain={domain}
            company={company}
            industry={industry}
            location={location}
            visible
            mode="clear"
            placement="band"
          />
        </div>
      </div>

      <div className="preview-cta">
        <div className="preview-cta-label">
          <strong>{displayDomain}</strong>
          This site was built for {displayName}. Activate it for $149.
        </div>
        <a href={orderUrl} className="preview-cta-btn">
          Activate this site →
        </a>
      </div>
    </div>
  );
}
